import { useStoreTheme } from '../../../store';
import { useState, useEffect, useRef } from 'react';
import { BannerNotification, NavigationTabs, Button } from '@oc-labs/wt-storybook';

export default function NotificationSidebar() {
    const { notificationSidebar, handleNotificationSidebar } = useStoreTheme();
    const [activeTab, setActiveTab] = useState('All');
    const sidebarRef = useRef(null);

    const closeModal = () => {
        handleNotificationSidebar();
    };
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                notificationSidebar
            ) {
                handleNotificationSidebar(); 
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [notificationSidebar]);

    return (
        <div ref={sidebarRef} className={`h-full bg-gray-100 shadow-lg transition-all duration-300 ease-in-out overflow-hidden ${notificationSidebar ? 'w-96' : 'w-0'}`}>

            <div className={`w-96 ${notificationSidebar ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300 flex flex-col h-full`}>

                <div className="flex justify-between items-center px-6 py-5 bg-gray-100">
                    <h2 className="text-xl font-semibold">
                        Notifications
                    </h2>

                    <div>
                        <Button
                            size={"small"}
                            onClick={closeModal}
                            type="overlay"
                            icon="✕"
                        />
                    </div>
                </div>

                <div className="px-6 py-4">
                    <BannerNotification
                        title="Add your address"
                        subtitle="Unlock app"
                        step={2}
                        totalSteps={4}
                        backgroundColor="#FFFFFF"
                    />
                </div>

                <div className="px-6 py-4">
                    <NavigationTabs
                        activeTab={activeTab}
                        onChange={setActiveTab}
                        tabs={[
                            { key: '1', label: 'All', children: '' },
                            { key: '2', label: 'Price alerts', children: '' },
                            { key: '3', label: 'Offers', children: '' },
                            { key: '4', label: 'News', children: '' },
                            { key: '5', label: 'Events', children: '' },
                        ]}
                    />
                </div>
            </div>
        </div>
    );
}